var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeatMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 438.1 257.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4,257.76c-13.47,0-24.4-10.93-24.4-24.4V91.92c0-13.47,10.93-24.4,24.4-24.4s24.4,10.93,24.4,24.4V233.37c0,13.47-10.93,24.4-24.4,24.4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M180.12,257.76c-13.47,0-24.4-10.93-24.4-24.4V64.3c0-13.47,10.93-24.4,24.4-24.4s24.4,10.93,24.4,24.4V233.37c0,13.47-10.93,24.4-24.4,24.4Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M257.97,257.76c-13.47,0-24.4-10.93-24.4-24.4V119.76c0-13.47,10.93-24.4,24.4-24.4s24.4,10.93,24.4,24.4v113.6c0,13.47-10.93,24.4-24.4,24.4Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M413.7,257.76c-13.47,0-24.4-10.93-24.4-24.4V119.76c0-13.47,10.93-24.4,24.4-24.4s24.4,10.93,24.4,24.4v113.6c0,13.47-10.93,24.4-24.4,24.4Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M335.83,257.76c-13.47,0-24.4-10.93-24.4-24.4v-70.72c0-13.47,10.93-24.4,24.4-24.4s24.4,10.93,24.4,24.4v70.72c0,13.47-10.93,24.4-24.4,24.4Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M102.25,257.76c-13.47,0-24.4-10.93-24.4-24.4V24.4c0-13.47,10.93-24.4,24.4-24.4s24.4,10.93,24.4,24.4V233.37c0,13.47-10.93,24.4-24.4,24.4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeatMap);
export default __webpack_public_path__ + "static/media/heatMap.a9fe595243dca9d48eafff4ed773ccc3.svg";
export { ForwardRef as ReactComponent };